import { toMillis } from "./ownership";

/**
 * Soft-delete model shared with the mobile app (plan 4.4): trashed files carry
 * `status: "DELETED"` + `deletedAt`, trashed folders `deletedAt`. Items stay in
 * the trash for TRASH_RETENTION_DAYS; after that the purge job (or the user)
 * deletes them permanently. Firestore rules only allow hard deletes of trashed
 * files and folders. A file on legal hold (3.13) can neither be trashed nor
 * purged.
 */
export const TRASH_RETENTION_DAYS = 30;

const DAY_MS = 24 * 60 * 60 * 1000;

export function isTrashed(item) {
  return !!item && (item.status === "DELETED" || !!item.deletedAt);
}

export function withoutTrashed(items) {
  return (items || []).filter((item) => !isTrashed(item));
}

/** Whole days until the item is purged; 0 once the retention period is over. */
export function daysUntilPurge(item, now = Date.now()) {
  const deletedAt = toMillis(item?.deletedAt);
  if (!deletedAt) return TRASH_RETENTION_DAYS;
  return Math.max(0, Math.ceil((deletedAt + TRASH_RETENTION_DAYS * DAY_MS - now) / DAY_MS));
}

export function isOnLegalHold(item) {
  return !!item?.legalHold?.active;
}

export function isPurgeDue(item, now = Date.now()) {
  if (isOnLegalHold(item)) return false;
  const deletedAt = toMillis(item?.deletedAt);
  return !!deletedAt && now - deletedAt >= TRASH_RETENTION_DAYS * DAY_MS;
}
